export default "__VITE_PUBLIC_ASSET__d5415aa0__"